<template>
    <transition name="animate">
        <div class="g pop-up">
            <component
                :is="computedType"
                :content="content"
                :sn="sn"
                @sendEvent="receiveEvent"
            ></component>
        </div>
    </transition>
</template>

<script>
    import alert from '@/popups/alert'
    import confirm from '@/popups/confirm'
    import prompt from '@/popups/prompt'
    import showSelect from '@/popups/select'
    import combobox from '@/popups/combobox'
    import range from '@/popups/range'
    import upload from '@/popups/upload'
    import uploadInput from '@/popups/uploadInput'
    import chart from '@/popups/chart'
    import showMap from '@/popups/map'
    import showTable from '@/popups/table' //不可使用原生 tag name
    import showSingle from '@/popups/showSingle'
    import editSingle from '@/popups/editSingle'
    import setTableTitle from '@/popups/setTableTitle'
    import chartAndTable from '@/popups/chartAndTable' //不可使用原生 tag name
    import aboutUs from '@/popups/aboutUs'
    import colorSet from '@/popups/colorSet'
    import login from '@/popups/login'
    import relogin from '@/popups/relogin'
    import changePassword from '@/popups/changePassword'
    import routerPush from '@/popups/routerPush'

    import { mapMutations } from 'vuex'

    export default {
        components: {
            alert,
            confirm,
            prompt,
            showSelect,
            combobox,
            range,
            upload,
            uploadInput,
            chart,
            showMap,
            showTable,
            showSingle,
            editSingle,
            setTableTitle,
            chartAndTable,
            aboutUs,
            login,
            relogin,
            changePassword,
            routerPush,
            colorSet,
            selectClass: resolve => require(['@/popups/selectClass'], resolve),
            addClient: resolve => require(['@/popups/addClient'], resolve),
            showSalse: resolve => require(['@/popups/showSalse'], resolve),
            showCalendarInfo: resolve => require(['@/popups/showCalendarInfo'], resolve),
            editCalendarEvent: resolve => require(['@/popups/editCalendarEvent'], resolve),
            editCalendarSource: resolve => require(['@/popups/editCalendarSource'], resolve),
            downloadShipping: resolve => require(['@/popups/downloadShipping'], resolve),
            downloadStatement: resolve => require(['@/popups/downloadStatement'], resolve),
            starRate: resolve => require(['@/popups/starRate'], resolve),
            videoBlock: resolve => require(['@/popups/videoBlock'], resolve),
            videoSelector: resolve => require(['@/popups/videoSelector'], resolve),
        },
        props: {
            type: {
                require: true
            },
            sn: {
                require: true
            },
            content: { //依照模板定義
                require: false
            }
        },
        computed: {
            computedType: function(){
                let _type = this.type;

                if( _type === 'select' || _type === 'map' || _type === 'table' ) {
                    let $type = _type.split('');

                    $type[0] = $type[0].toUpperCase();

                    _type = $type.join('');

                    return 'show'+ _type;

                }else {
                    return _type;
                }
            },
        },
        methods: {
            ...mapMutations([
                'clearPopUp'
            ])
        }
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in 150ms;
    }

    .animate-leave-active {
        animation: animate-out 150ms;
    }

    @keyframes animate-in {
        0% {
            transform: scale(1.1);
            opacity: 0;
        }

        100% {
            transform: scale(1);
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .g.pop-up {
        @extend %mask;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1001;

        $add: '';

        @for $i from 1 through 10 { //目前允許 popup 疊 10 層
            $add: ' #{$add} + .g.pop-up ';

            &#{$add} {
                z-index: 1001 + $i;
            }
        }

        &::v-deep {
            $size: calc(100% - 60px);
            
            .g.pop-up-inner {
                display: inline-flex;
                flex-direction: column;
                position: relative;
                background-color: $white;
                z-index: 1;
                border-radius: $border-radius;
                // box-shadow: 0 0 $interval-xxl $light;
                max-width: calc(100vw - 60px);
                max-height: calc(100vh - 60px);
                border: $border;

                @include media('phone') {
                    max-width: none;
                    max-height: none;
                    width: calc(100vw - 40px) !important;
                    height: calc(100vh - 60px);
                }
            }

            .g.pop-up-content {
                flex-grow: 1;
                overflow: auto;
                position: relative;
                padding: $interval-m $interval-xxl;
                overscroll-behavior: contain;
                // max-height: calc(100vh - 140px);
                // max-width: calc(100vw - 100px);

                // @include media('mobile') {
                //     max-width: calc(100vw - 40px);
                //     padding: 0 $interval-m;
                // }

                // &.iframe {

                // }

                // &.htmlframe {

                // }

                // &.html, &.text {
                //     overflow: auto;
                // }

                // &.is-loading {
                //     @extend %loading;

                //     &::before {
                //         position: absolute;
                //         bottom: 0;
                //         right: 0;
                //         width: auto;
                //         height: auto;
                //     }
                // }
            }

            .g.pop-up-content-inner {

                > div {
                    min-width: 200px;
                    max-width: 100%;
                    min-height: 70px;
                    max-height: calc(100vh - 240px);

                    @include media('mobile') {
                        width: auto !important;
                    }

                    img {

                        @include media('mobile') {
                            height: auto !important;
                            width: auto !important;
                        }
                    }
                }

                .g.search {

                    + .md.major-table {
                        margin-top: $interval-m;
                    }
                }

                // .iframe {
                //     padding: 0;
                //     display: block;
                //     height: 300px;
                //     overflow: auto;
                //     -webkit-overflow-scrolling: touch;

                //     @include media('mobile') {
                //         padding: 0;
                //     }
                // }

                // iframe {
                //     width: 100% !important;
                //     height: calc(100% - 10px) !important;
                //     min-height: 0 !important;
                // }
            }
        }
    }
</style>
